import React, { useEffect, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Menu, X, Search, ArrowRight } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
const navLinks = [{
  label: 'Platform',
  to: '/platform'
}, {
  label: 'BAS',
  to: '/breach-and-attack-simulation'
}, {
  label: 'Research',
  to: '/research'
}];
export function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const location = useLocation();
  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 20);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  useEffect(() => {
    setMobileMenuOpen(false);
  }, [location.pathname]);
  return <header className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 border-b border-picus-border ${scrolled ? 'bg-picus-surface/90 backdrop-blur-md py-4' : 'bg-transparent py-6'}`} data-id="element-299">
      <div className="max-w-7xl mx-auto px-6 flex items-center justify-between" data-id="element-300">
        {/* Left Nav */}
        <nav className="hidden lg:flex items-center gap-12 flex-1" data-id="element-301">
          {navLinks.map(link => {
          const isActive = location.pathname === link.to || link.to !== '/' && location.pathname.startsWith(link.to);
          return <Link key={link.to} to={link.to} className={`nav-link ${isActive ? 'text-picus-accent border-b-picus-accent' : ''}`} data-id="element-302">
                {link.label}
              </Link>;
        })}
        </nav>

        {/* Center Logo */}
        <Link to="/" className="flex-shrink-0 z-10 flex-1 flex justify-center" data-id="element-303">
          <img src="https://www.picussecurity.com/hubfs/light_logo-original-SVG.svg" alt="Picus Security" className="h-6 w-auto" data-id="element-304" />
        </Link>

        {/* Right CTAs */}
        <div className="hidden lg:flex items-center justify-end gap-8 flex-1" data-id="element-305">
          <Link to="/contact" className="nav-link flex items-center gap-2" data-id="element-306">
            Try or Buy <ArrowRight className="w-3 h-3" data-id="element-307" />
          </Link>
          <a href="https://app.picussecurity.com" target="_blank" rel="noopener noreferrer" className="nav-link" data-id="element-308">
            Log In
          </a>
        </div>

        {/* Mobile Toggle */}
        <button className="lg:hidden text-white p-2 z-10 relative" onClick={() => setMobileMenuOpen(!mobileMenuOpen)} data-id="element-309">
          {mobileMenuOpen ? <X data-id="element-310" /> : <Menu data-id="element-311" />}
        </button>
      </div>

      {/* Mobile Menu */}
      <AnimatePresence data-id="element-312">
        {mobileMenuOpen && <motion.div initial={{
        opacity: 0,
        y: -20
      }} animate={{
        opacity: 1,
        y: 0
      }} exit={{
        opacity: 0,
        y: -20
      }} className="lg:hidden absolute top-full left-0 right-0 bg-picus-surface border-b border-picus-border shadow-2xl" data-id="element-313">
            <div className="px-6 py-6 flex flex-col gap-6" data-id="element-314">
              {navLinks.map(link => <Link key={link.to} to={link.to} className="font-mono text-sm uppercase tracking-widest text-picus-muted hover:text-white transition-colors" data-id="element-315">
                  {link.label}
                </Link>)}
              <div className="h-px bg-picus-border w-full my-2" data-id="element-316" />
              <Link to="/contact" className="font-mono text-sm uppercase tracking-widest text-white flex items-center gap-2" data-id="element-317">
                Try or Buy <ArrowRight className="w-4 h-4" data-id="element-318" />
              </Link>
              <a href="https://app.picussecurity.com" target="_blank" rel="noopener noreferrer" className="font-mono text-sm uppercase tracking-widest text-picus-muted hover:text-white transition-colors" data-id="element-319">
                Log In
              </a>
            </div>
          </motion.div>}
      </AnimatePresence>
    </header>;
}